module.exports = __webpack_public_path__ + "static/media/genie4.77a17629.webm";